import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FastTrackDashboard } from '../components/FastTrackDashboard';
import { AreasOfConcentration } from '../components/AreasOfConcentration';
import { MissionSection } from '../components/MissionSection';
import { InsuranceSection } from '../components/InsuranceSection';
import { GetInvolved } from '../components/GetInvolved';
export function HomePage() {
  return <>
      <HeroSection data-id="element-525" />
      <FastTrackDashboard data-id="element-526" />
      <AreasOfConcentration data-id="element-527" />
      <MissionSection data-id="element-528" />
      <InsuranceSection data-id="element-529" />
      <GetInvolved data-id="element-530" />
    </>;
}